import { navigateTo } from "@app/lib/router.ts";
import { ViewModeToggle } from "./ViewModeToggle.tsx";

interface Props {
  onOpenSearch: () => void;
}

export function Header({ onOpenSearch }: Props) {
  return (
    <header className="border-b border-parchment-400/60 bg-parchment-100 sticky top-0 z-20">
      <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
        <button
          type="button"
          onClick={() => navigateTo({ kind: "landing" })}
          className="flex items-center gap-3 hover:opacity-80 transition-opacity"
          aria-label="cklibrary home"
        >
          <img src="/brand/logo-128.png" alt="" width="36" height="36" className="block" />
          <span className="font-serif font-semibold text-2xl tracking-tight text-parchment-900">
            cklibrary
          </span>
        </button>
        <div className="flex gap-2 items-center text-sm">
          <button
            type="button"
            onClick={onOpenSearch}
            className="hidden sm:inline-flex items-center px-3 py-1.5 border border-parchment-400 hover:bg-parchment-200/60 rounded font-mono text-xs text-parchment-700 transition-colors whitespace-nowrap"
          >
            search <kbd className="ml-1 text-[10px]">⌘K</kbd>
          </button>
          <button
            type="button"
            onClick={() => navigateTo({ kind: "list" })}
            className="px-3 py-1.5 hover:bg-parchment-200/60 rounded text-parchment-800 font-medium transition-colors"
          >
            All docs
          </button>
          <ViewModeToggle />
        </div>
      </div>
    </header>
  );
}
